import { KeycloakAdapter } from 'keycloak-js';
import { addStateToLocalStorage, ICallbackState } from '../_helpers/localStorage';
import { LOGIN_URL, LOGOUT_URL } from '../auth.constant';

export const createProxyAdapter = (getIdToken: () => string): KeycloakAdapter => ({
  login: async function(options) {
    const state = crypto.randomUUID();
    const redirectUri = options?.redirectUri || location.href.slice(location.origin.length); // Relative uri to show a nice address
    const callbackState: ICallbackState = {
      state,
      redirectUri: options?.redirectUri || location.href, // Full uri in state
      loginOptions: options,
    };

    const params = new URLSearchParams([
      ['redirect_uri', redirectUri],
      ['state', state],
    ]);

    if (options?.locale) {
      params.append('ui_locales', options.locale);
    }

    addStateToLocalStorage(callbackState);

    window.location.href = `${location.origin}${LOGIN_URL}?${params.toString()}`;
  },

  logout: async function() {
    const idToken = getIdToken();
    const params = new URLSearchParams([
      ['post_logout_redirect_uri', location.origin],
    ]);

    // To be removed when id_token will be added in Control Plane
    document.cookie = `id_token=${idToken}; path=/logout; SameSite=None; Secure`;
    window.location.href = `${location.origin}${LOGOUT_URL}?${params.toString()}`;
    return Promise.resolve();
  },

  redirectUri: function(options) {
    return options?.redirectUri || location.href;
  },

  register: async function() {
    throw new Error('"register" not supported');
  },

  accountManagement: async function() {
    throw new Error('accountManagement not supported');
  },
});
